import { useState } from 'react';

import { Box, Text, Flex, Image, Skeleton } from '@chakra-ui/react';
import { AiFillCheckCircle } from 'react-icons/ai'
import MakeTemplateTutorialImage from './styles/images/make-template-tutorial.png';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { displayEmoji } from '../../helpers/dsr-helpers';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';


export default function CreateTemplatesTutorialModal({ handleCloseModal }) {

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={AiFillCheckCircle} color='brand.500' boxSize="1.6em" />
        <Box color='white'>Tutorial: Creating a Room Template</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      <DisplayContent handleCloseModal={handleCloseModal} />
    </LaunchdeckModal>
  );
}



function DisplayContent({ handleCloseModal }) {
  const [imageClassName, setImageClassName] = useState('image-loading__in-progress')
  return (
    <Flex direction='column' alignItems='center' justify='center' w='100%' py='1.5em'>
      <Flex direction='column' alignItems='center' justify='center' w='100%'>
        <Box >
          <Skeleton height="200px" width="200px" display={(imageClassName === 'image-loading__in-progress' ? 'unset' : 'none')} />
          <Image src={MakeTemplateTutorialImage} className={imageClassName}
            visibility={(imageClassName === 'image-loading__in-progress' ? 'none' : '')}
            onLoad={() => setImageClassName('image-loading__completed')}
            width='26em'
            alt="Make Room Template tutorial" />
        </Box>

        <Flex direction='column' w='100%' fontSize='0.9em' mt='1em' mb='3em' fontWeight='400' lineHeight='1.375em' gap='0.5em'>
          <Text textAlign='center' mt='0.5em' my={['1em', '0em', '0em', '0em']}>Hover across a published Room & select <i>Make template</i> option.</Text>
          <Flex align='center' justify='center' gap={4}>
            And that's it! 		<span>{displayEmoji('celebrate')} </span>
          </Flex>
        </Flex>

        <LaunchdeckButton bg='brand.500' color='white' px='2em' w={['100%', 'auto']} onClick={() => handleCloseModal()} label='OK, got it' />
      </Flex>
    </Flex>
  )
}
